export default {
    baseStyle: {
        new: {fontSize: '16px', fontWeight: '700', mb: 1},
        addressDropdown: {
            height: '40px',
            borderRadius: '0px',
            _focus: {
                borderstyle: 'solid',
                borderColor: 'black',
                borderRadius: '4px',
                borderWidth: '2px',
                paddingRight: '1rem !important'
            },
            _invalid: {
                color: 'red.550',
                backgroundColor: 'red.750',
                border: '1px solid',
                borderColor: 'red.550',
                borderRadius: 0,
                _focus: {
                    borderstyle: 'solid',
                    borderColor: 'black',
                    borderRadius: '4px',
                    borderWidth: '2px'
                }
            }
        },
        addressBox: {
            marginLeft: '1.5rem'
        }
    }
}
